import { ElMessageBox } from 'element-plus'
import store from '@/store';
const allowedInterfaces = [
	'api/Exam/getHomeExamCount',
	'api/Common/getProvList',
	'api/Common/getLanguageList',
];
const fetchs = {
	setToken: function (access_token, user_id) {
		localStorage.setItem("access_token", access_token);
		localStorage.setItem("user_id", user_id);
	},
	getToken() {
		return localStorage.getItem("access_token");
	},
	getUserId() {
		return localStorage.getItem("user_id");
	},
	isLogin: function () {
		return localStorage.getItem("token") ? true : false;
	},
	logout: function () {
		return new Promise((resolve, reject) => {
			try {
			// 清除本地存储
			localStorage.removeItem("access_token");
			localStorage.removeItem("user_id");
			localStorage.removeItem('userInfo');
			localStorage.removeItem('pid');

			// 直接使用 window.location.href 跳转回首页
			window.location.href = '/#/';
			window.location.reload();
			// 解析 Promise
			resolve();
			} catch (error) {
			reject(error);
			}
		});
	},
	request: function (requestData) {
		let url = requestData.url,
			postData = requestData.data,
			method = requestData.method
		const access_token = fetchs.getToken() || "";
		const user_id = fetchs.getUserId() || "";
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: method,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'access-token': access_token,
					'user-id': user_id,
				},
				body: method === 'POST' ? new URLSearchParams(postData).toString() : null
			})
			.then(response => response.json())
			.then(res => {
				if (res.code !== 200) {
					console.log("************接口报错，信息如下*********");
					// 请求路径
					console.log("请求路径：" + JSON.stringify(url));
					// 请求数据
					console.log("请求参数：" + JSON.stringify(postData));
					// 输出数据
					console.log("返回数据：" + JSON.stringify(res));
				}
				// 页面白名单
				// const whiteList = [
				// 	'/',
				// 	'/RegisterLogin',
				// 	// '/UsageGuide'
				// ];
				

				if (res.code === 201) {
					if (!allowedInterfaces.includes(url)) {
						ElMessageBox.alert('请重新登录', '提示', {
						confirmButtonText: '确定',
						type: 'error',
						showClose: false, // 去掉右上角的X按钮
						closeOnClickModal: false, // 点击模态框外区域不关闭
						closeOnPressEscape: false // 按下ESC键不关闭
						}).then(() => {
						// 弹窗确认后执行 fetchs.logout()
						fetchs.logout()
							.then(() => {
								// 调用 store/index.js 中的 userLogout mutation
								store.commit('userLogout');
								resolve(res);
							})
							.catch(error => {
								reject(error);
							});
						});
					}
				}

				if (res.code === 500) {
					console.log("服务错误");
					reject(res);
				}

				if (res.code == -1) {
					// 未登陆逻辑处理
					localStorage.removeItem("token");

					if (localStorage.getItem('userInfo')) {
						localStorage.removeItem('userInfo');
					}
				}
				resolve(res);
			})
			.catch(res => {
				console.log("网络不给力，请稍后再试~");
				reject(res);
			});
		});
	},
	downloadFile: function (requestData) {
		let url = requestData.url,
			method = requestData.method,
			fileName = requestData.fileName || 'default.xlsx';
		const access_token = fetchs.getToken() || "";
		const user_id = fetchs.getUserId() || "";
		return new Promise((resolve, reject) => {
			fetch(url, {
			method: method,
			headers: {
				'access-token': access_token,
				'user-id': user_id,
			},
			responseType: 'blob'  // 设置响应类型为 blob
			})
			.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.blob();
			})
			.then(blob => {
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = fileName;  // 您可以根据实际情况设置文件名
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(link.href);
			resolve({ success: true });
			})
			.catch(error => {
			console.error('下载失败:', error);
			reject(error);
			});
		});
	}
};


export default fetchs
